import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useUser } from "../context/UserContext";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

import api from "../utils/api"; // Ensure the API utility is correctly configured
import Clicked from "../assets/Clicked.png";
import Unclicked from "../assets/Unclicked.png";
import Cross from "../assets/cross.png";
import heroImage from "../assets/a3532d9a5c1cd9b83f8184c8b0178a92.png"; // Replace with the correct path
import Logo from "../assets/layer1.png"; // Replace with the correct path
import Register from "./Register"; // Import Register component
import ResetPassword from "./ResetPassword";
import ForgotPasswordPopup from "./ForgotPasswordPopup";

const Login = ({ onClose, onGuestCheckout }) => {
  const { saveToken } = useAuth(); // Save the token in AuthContext okk
  const { setUserData } = useUser(); // Set user data in UserContext
  const [email, setEmail] = useState(""); // Email state
  const [password, setPassword] = useState(""); // Password state
  const [error, setError] = useState(""); // Error state
  const [showRegister, setShowRegister] = useState(false); // Register popup visibility\
  const [showPassword, setShowPassword] = useState(false); // Password visibility state
  const [showForgotPopup, setShowForgotPopup] = useState(false);

  const navigate = useNavigate(); // Navigation hook

  // Use effect to populate email and password from localStorage if available
  useEffect(() => {
    const savedEmail = localStorage.getItem("email");
    const savedPassword = localStorage.getItem("password");

    if (savedEmail) setEmail(savedEmail);
    if (savedPassword) setPassword(savedPassword);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault(); // Prevent form submission
    setError(""); // Clear error messages

    try {
      const response = await api.post("/users/login", { email, password }); // API call to log in
      const { token, user } = response.data; // Extract token and user data from response
      saveToken(token); // Save token in AuthContext
      setUserData(user); // Save user data in UserContext

      // Save token and user data in local storage
      localStorage.setItem("authToken", token);
      localStorage.setItem("userData", JSON.stringify(user));

      // Optionally save email and password for auto-filling in the next login
      localStorage.setItem("email", email);
      localStorage.setItem("password", password);

      console.log("Token:", token); // Debugging log
      onClose(); // Close the login popup
      window.location.reload(); // Refresh the page
    } catch (error) {
      console.error(
        "Login error:",
        error.response ? error.response.data : error.message
      );
      setError("Your Email and/or Password is invalid."); // Set error message
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      const decodedToken = jwtDecode(token);
      if (decodedToken.exp * 1000 > Date.now()) {
        // Token is valid
        setUserData(JSON.parse(localStorage.getItem("userData")));
      } else {
        localStorage.removeItem("authToken");
        localStorage.removeItem("userData");
      }
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(async () => {
      try {
        const response = await api.post("/users/refresh-token", {
          token: localStorage.getItem("authToken"),
        });
        localStorage.setItem("authToken", response.data.token);
      } catch (err) {
        console.error("Token refresh failed:", err);
      }
    }, 15 * 60 * 1000); // Refresh every 15 minutes
    return () => clearInterval(interval);
  }, []);

  return (
    <>
    <div className=" fixed inset-0 flex md:flex-row flex-row items-center justify-center z-50 bg-gray-400 bg-opacity-30 backdrop-blur-sm">
      <div className="ml-10 mr-10 backdrop-blur-sm bg-primary rounded-2xl  shadow-lg p-8 max-w-md w-full relative overflow-y-auto max-h-screen">
        {/* Close Button */}
        <img
          src={Cross} // Replace with your image path
          alt="Close"
          className="absolute top-4 right-4 cursor-pointer w-3 h-3 md:w-5 md:h-5 hover:opacity-75"
          onClick={onClose}
        />

        {/* Logo and Title */}
        <div className="text-start mb-6">
          <h2 className="text-black  text-3xl font-bold  ">Sign In</h2>
          <p
            className="mt-4 font-inter"
            style={{ color: "rgba(25, 25, 25, 0.6)" }}
          >
            Enter details
          </p>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label
              className={`block text-sm font-medium font-bold mb-1 ml-1.5 ${
                error ? "text-red-600" : "text-black"
              }`}
            >
              Email
            </label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className={`w-full bg-primary text-black px-4 py-2 border-[2px] rounded focus:outline-none focus:ring ${
                error
                  ? "border-[#d10000] focus:ring-[#d10000]"
                  : "border-black focus:ring-yellow-400"
              }`}
            />
          </div>
          <div className="relative">
            <label
              className={`block text-sm font-medium font-bold mb-1 ml-1.5 ${
                error ? "text-red-600" : "text-black"
              }`}
            >
              Password
            </label>
            <input
              type={showPassword ? "text" : "password"}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className={`w-full bg-primary text-black px-4 py-2 border-[2px] rounded focus:outline-none focus:ring ${
                error
                  ? "border-[#d10000] focus:ring-[#d10000]"
                  : "border-black focus:ring-yellow-400"
              }`}
            />

            <img
              src={showPassword ? Clicked : Unclicked}
              alt="Toggle visibility"
              className="absolute top-10 right-3 h-3 cursor-pointer"
              onClick={() => setShowPassword(!showPassword)}
            />
          </div>

          {error && (
            <div className="relative flex justify-center top-1">
              <div className="bg-red-600 text-white px-4 py-2 rounded text-center font-inter font-medium relative z-10 text-xs md:text-base whitespace-nowrap">
                Your Email and/or Password is invalid.
              </div>
              <div className="absolute -top-1 w-4 h-3 md:w-10 md:h-9 md:-top-1 bg-red-600 rounded transform rotate-45 z-0"></div>
            </div>
          )}

          <button
            type="submit"
            className="w-1/4 bg-transparent text-black border border-black rounded-lg text-wte font-bold py-2 hover:bg-black hover:text-white transition duration-200 "
          >
            Sign In
          </button>
          <p
            className="mt-4 text-sm text-black hover:underline cursor-pointer"
            onClick={() => setShowForgotPopup(true)}
          >
            Forgot password?
          </p>
          {/* <p className="text-sm text-black text-left -mt-4">
            <Link
              to="/reset-password"
              type="button"
              className="underline"
              onClick={onClose}
            >
              Forgot password?
            </Link>
          </p> */}
          <p className="text-sm text-black text-left mt-4">
            <br />
            Don't have an account?
            <br />
            <Link
              // to=""                           // add cashback linking
              type="button"
              className="underline font-bold"
              onClick={onClose}
            >
              Create your account now and get $10 Cashback today.
            </Link>
          </p>
        </form>
      </div>
    </div>
      {showForgotPopup && (
        <ForgotPasswordPopup onClose={() => setShowForgotPopup(false)} />
      )}
    </> 
  );
};

export default Login;
